/** Catalog id of the Portainer-Run add-on. */
export const PORTAINER_RUN_ADDON_ID = 'portainer-run';
